import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGift = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 8,
			width: 18,
			height: 4,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 8v13" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.5 8a2.5 2.5 0 0 1 0-5C9 3 12 8 12 8" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.5 8a2.5 2.5 0 0 0 0-5C15 3 12 8 12 8" })
	]
});
export default SvgGift;
